/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

export interface SettingData {
  key: string;
  value: string | undefined;
  localValue: string | undefined;
}

export function getValue(setting: SettingData | undefined): string | undefined {
  return setting?.localValue ?? setting?.value;
}

export interface SettingsResponse {
  version: string;
  etag: string | undefined;
  settings: Map<string, string>;
  code: string;
  message: string;
}

export interface SettingsData {
  version: string;
  etag: string | undefined;
  settings: Map<string, SettingData>;
}
